import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-users"
export default class AdminUsers extends Controller {
  static targets = [
    'role',
    'password',
    'combinedSchoolField',
    'combinedSchoolSelect',
    'localAuthFlag'
  ]

  localAuthFlagChanged() {
    this.passwordTarget.disabled = !this.localAuthFlagTarget.checked;
  }

  roleChanged() {
    if (this.roleTarget.value === 'teacher') {
      this.combinedSchoolFieldTarget.hidden = false;
      this.combinedSchoolSelectTarget.disabled = false;
    } else {
      this.combinedSchoolFieldTarget.hidden = true;
      this.combinedSchoolSelectTarget.disabled = true;
    }
  }
}
